<div class="flex flex-col gap-2">
  @for (control of controls(); track control.id; let idx = $index) {
    <div class="flex flex-col gap-1.5 rounded border border-neutral-100 p-2">
      <div class="flex items-center justify-between">
        <div class="flex items-center gap-1.5">
          <span class="rounded bg-neutral-100 px-1 py-px text-[10px] text-neutral-400">
            {{ control.type }}
          </span>
          <span class="text-xs font-medium text-neutral-600">{{ control.label }}</span>
        </div>
        <dojo-icon-button icon="trash" [size]="'xs'" (click)="onDeleteControl(idx)" />
      </div>

      <div class="grid grid-cols-2 gap-1.5">
        <dojo-text-input label="Label" [formCtrl]="getTextCtrl(idx, 'label')" [size]="'s'" />
        <dojo-single-select
          label="Position"
          [formCtrl]="getSelectCtrl(idx, 'position')"
          [options]="positionOptions"
          optionLabel="label"
          optionValue="value"
          [size]="'s'"
          placeholder="Default"
          (selectionChange)="onControlFieldChange(idx, 'position', $event)"
        />
      </div>

      <!-- Slider-specific -->
      @if (control.type === 'slider') {
        <dojo-text-input label="Param" [formCtrl]="getTextCtrl(idx, 'param')" [size]="'s'" placeholder="f.a" />
        <div class="grid grid-cols-3 gap-1.5">
          <dojo-number-input label="Min" [formCtrl]="getNumberCtrl(idx, 'rangeMin')" [step]="1" [size]="'s'" />
          <dojo-number-input label="Max" [formCtrl]="getNumberCtrl(idx, 'rangeMax')" [step]="1" [size]="'s'" />
          <dojo-number-input
            label="Step"
            [formCtrl]="getNumberCtrl(idx, 'rangeStep')"
            [step]="0.1"
            [min]="0.01"
            [size]="'s'"
          />
        </div>
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-number-input
            label="Default"
            [formCtrl]="getNumberCtrl(idx, 'defaultValue')"
            [step]="0.1"
            [size]="'s'"
          />
          <dojo-single-select
            label="Color"
            [formCtrl]="getSelectCtrl(idx, 'color')"
            [options]="colorOptions"
            optionLabel="label"
            optionValue="value"
            [size]="'s'"
            placeholder="Default"
            (selectionChange)="onControlFieldChange(idx, 'color', $event)"
          />
        </div>
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-single-select
            label="Variant"
            [formCtrl]="getSelectCtrl(idx, 'variant')"
            [options]="variantOptions"
            optionLabel="label"
            optionValue="value"
            [size]="'s'"
            placeholder="Default"
            (selectionChange)="onControlFieldChange(idx, 'variant', $event)"
          />
          <mat-slide-toggle
            class="self-center"
            [checked]="isSliderEditable(control)"
            (change)="onControlFieldChange(idx, 'editable', $event.checked)"
          >
            Editable
          </mat-slide-toggle>
        </div>
      }

      <!-- Button-specific -->
      @if (control.type === 'button') {
        <div class="grid grid-cols-2 gap-1.5">
          <dojo-text-input
            label="Icon"
            [formCtrl]="getTextCtrl(idx, 'icon')"
            [size]="'s'"
            placeholder="magnifying-glass-plus"
          />
          <mat-slide-toggle
            class="self-center"
            [checked]="isButtonShowLabel(control)"
            (change)="onControlFieldChange(idx, 'showLabel', $event.checked)"
          >
            Show Label
          </mat-slide-toggle>
        </div>
      }
    </div>
  }

  <!-- Add control -->
  <div class="mt-1 flex items-center gap-1.5">
    <dojo-single-select
      [formCtrl]="newControlTypeCtrl"
      [options]="controlTypeOptions"
      optionLabel="label"
      optionValue="value"
      [size]="'s'"
      placeholder="Add control..."
      class="flex-1"
    />
    <button
      class="flex items-center gap-1 rounded px-1.5 py-1 text-[11px] text-neutral-400 hover:bg-neutral-50 hover:text-neutral-600"
      (click)="onAddControl()"
    >
      <dojo-icon icon="plus" [size]="10" />
      Add
    </button>
  </div>
</div>
